import React from "react";
import { PropLabel } from "../PropX";
import * as SelectMenu from "../SelectMenu_v2";
import { mediaQueries } from "../style";
import { DisplayOption, mapResourceLocationToDisplayOption } from "./displayOption";
import { ResourceLocation } from "./types";

type Props = {
  /**
   * The name of the select menu.
   */
  name: string;

  /**
   * The value of the currently selected option.
   */
  selected: string;

  onSelect: (slug: string) => void;

  /**
   * The location options that appear in the select menu.
   */
  options: ResourceLocation[];

  /**
   * Whether the select menu is disabled.
   * @default false
   */
  disabled?: boolean;

  /**
   * A label to display above the select menu.
   * @default undefined
   */
  label?: PropLabel;

  /**
   * Testing utility function. Called with each option's `value` prop.
   * @default undefined
   */
  "data-testid"?: (value: string) => string;
};

const mapResourceLocationsToDisplayOptions = (regions: ResourceLocation[], mobile: boolean) => {
  const options: DisplayOption[] = [];

  for (const resourceLocation of regions) {
    const next = mapResourceLocationToDisplayOption(resourceLocation, mobile);

    options.push(next);
  }

  return options;
};

export const ResourceLocationSelectMenu: React.FC<Props> = (props) => {
  const { options, name, selected, onSelect, disabled = false, label = "Choose a datacenter region" } = props;
  const testId = props["data-testid"];

  const isMobile = mediaQueries.smallMax.useMatchesBreakpoint();
  const displayOptions = React.useMemo(() => mapResourceLocationsToDisplayOptions(options, isMobile), [options, isMobile]);

  return (
    <SelectMenu.Base
      name={name}
      label={label}
      selected={selected}
      onSelect={onSelect}
      options={displayOptions}
      disabled={disabled}
      data-testid={testId}
    />
  );
};
